export const VIEW_SPACE_EXTERNAL_COLLABORATORS_DIALOG_BEST_EFFORT_TASK_NAME =
	'ViewSpaceExternalCollaboratorsDialogQuery';
